import React, { useEffect, useState } from 'react';
import './InsanKaynaklariSection.css';

const API_BASE = 'https://apiportal.mbsays.com/public/api';

const InsanKaynaklariSection = () => {
  const [activeTab, setActiveTab] = useState('advance');
  const token = sessionStorage.getItem('authToken');
  const me = JSON.parse(sessionStorage.getItem('user') || '{}');
  const isAdmin = me.role === 'admin';

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`
  };

  const [requests, setRequests] = useState([]);
  const [vacations, setVacations] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/advance-requests`, { headers })
      .then(res => res.json())
      .then(setRequests)
      .catch(console.error);

    fetch(`${API_BASE}/vacations`, { headers })
      .then(res => res.json())
      .then(setVacations)
      .catch(console.error);
  }, []);

  const handleStatusChange = (id, newStatus) => {
    fetch(`${API_BASE}/advance-requests/${id}/status`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ status: newStatus.toLowerCase() })
    })
      .then(res => {
        if (!res.ok) throw new Error('Durum güncellenemedi');
        setRequests(prev =>
          prev.map(r => (r.id === id ? { ...r, status: newStatus.toLowerCase() } : r))
        );
      })
      .catch(console.error);
  };

  const handleLeaveStatusChange = (id, action) => {
    const note = prompt(`${action === 'approve' ? 'Onay' : 'Red'} gerekçesini yazınız:`);
    if (note === null) return;

    const url = `${API_BASE}/vacations/${id}/${action}`;
    fetch(url, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ admin_note: note })
    })
      .then(res => {
        if (!res.ok) throw new Error('Durum güncellenemedi');
        setVacations(prev =>
          prev.map(v =>
            v.id === id ? { ...v, status: action === 'approve' ? 'approved' : 'rejected', admin_note: note } : v
          )
        );
      })
      .catch(console.error);
  };

  const pendingVacations = vacations.filter(v => v.status === 'pending');
  const approvedVacations = vacations.filter(v => v.status === 'approved');
  const rejectedVacations = vacations.filter(v => v.status === 'rejected');

  const pendingRequests = requests.filter(r => r.status === 'pending');
  const approvedRequests = requests.filter(r => r.status === 'approved');
  const rejectedRequests = requests.filter(r => r.status === 'rejected');

  return (
    <div className="insan-kaynaklari-tabs">
      <div className="tab-buttons">
        <button className={activeTab === 'advance' ? 'active' : ''} onClick={() => setActiveTab('advance')}>Avans Talepleri</button>
        <button className={activeTab === 'leave' ? 'active' : ''} onClick={() => setActiveTab('leave')}>İzin Talepleri</button>
      </div>

      {activeTab === 'advance' && (
        <>
          <h3>Bekleyen Talepler</h3>
          <AdvanceTable data={pendingRequests} isAdmin={isAdmin} onStatusChange={handleStatusChange} />

          <h3>Onaylanan Talepler</h3>
          <AdvanceTable data={approvedRequests} />

          <h3>Reddedilen Talepler</h3>
          <AdvanceTable data={rejectedRequests} />
        </>
      )}

      {activeTab === 'leave' && (
        <div className="leave-wrapper">
          <h3>Bekleyen Talepler</h3>
          <LeaveTable data={pendingVacations} isAdmin={isAdmin} onStatusChange={handleLeaveStatusChange} />

          <h3>Onaylanan Talepler</h3>
          <LeaveTable data={approvedVacations} />

          <h3>Reddedilen Talepler</h3>
          <LeaveTable data={rejectedVacations} />
        </div>
      )}
    </div>
  );
};

const AdvanceTable = ({ data, isAdmin = false, onStatusChange }) => (
  <table className="advance-table">
    <thead>
      <tr>
        <th>Kullanıcı</th>
        <th>Oluşturulma</th>
        <th>Tarih</th>
        <th>Tutar</th>
        <th>Açıklama</th>
        <th>Durum</th>
        {isAdmin && <th>İşlem</th>}
      </tr>
    </thead>
    <tbody>
      {data.map(r => (
        <tr key={r.id}>
          <td>{r.user?.name || '-'}</td>
          <td>{r.creation_date}</td>
          <td>{r.advance_date}</td>
          <td>{r.amount}</td>
          <td>{r.description}</td>
          <td>
            {r.status === 'approved' && 'Onaylandı'}
            {r.status === 'rejected' && 'Reddedildi'}
            {r.status === 'pending' && 'Bekliyor'}
          </td>
          {isAdmin && (
            <td className="status-buttons">
              {r.status === 'pending' ? (
                <>
                  <button className="edit-button" onClick={() => onStatusChange(r.id, 'Approved')}>Onayla</button>
                  <button className="delete-button" onClick={() => onStatusChange(r.id, 'Rejected')}>Reddet</button>
                </>
              ) : (
                '-'
              )}
            </td>
          )}
        </tr>
      ))}
    </tbody>
  </table>
);

const LeaveTable = ({ data, isAdmin = false, onStatusChange }) => (
  <table className="leave-table">
    <thead>
      <tr>
        <th>Kullanıcı</th>
        <th>Başlangıç</th>
        <th>Bitiş</th>
        <th>Gün</th>
        <th>Not</th>
        <th>Durum</th>
        <th>Admin Notu</th>
        {isAdmin && onStatusChange && <th>İşlem</th>}
      </tr>
    </thead>
    <tbody>
      {data.map(v => (
        <tr key={v.id}>
          <td>{v.user?.name || '-'}</td>
          <td>{new Date(v.start_date).toLocaleDateString('tr-TR')}</td>
          <td>{new Date(v.end_date).toLocaleDateString('tr-TR')}</td>
          <td>{v.days_requested}</td>
          <td>{v.note || '-'}</td>
          <td>{v.status === 'approved' ? 'Onaylandı' : v.status === 'rejected' ? 'Reddedildi' : 'Bekliyor'}</td>
          <td>{v.admin_note || '-'}</td>
          {isAdmin && onStatusChange && v.status === 'pending' && (
            <td className="buttons">
              <button className="edit-button" onClick={() => onStatusChange(v.id, 'approve')}>Onayla</button>
              <button className="delete-button" onClick={() => onStatusChange(v.id, 'reject')}>Reddet</button>
            </td>
          )}
        </tr>
      ))}
    </tbody>
  </table>
);

export default InsanKaynaklariSection;
